import PropTypes from 'prop-types';
import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { FormattedMessage, injectIntl } from 'react-intl';
import { bindAll } from '@bibliocommons/utils-react';
import { bibShape, shelfItemShape, ugcSummaryShape } from '@bibliocommons/bc-prop-types';
import TextUGCEditor from '../TextUGCEditor';

const CHARACTER_LIMIT = 4000;

export class SummaryUGCEditor extends React.PureComponent {
  constructor(props) {
    super(props);
    bindAll(this);

    const { existingSummary } = this.props;
    this.state = {
      summary: existingSummary ? existingSummary.get('summary', '') : ''
    };
  }

  handleTextChange(value) {
    this.setState({ summary: value });
  }

  handleSave(callback) {
    const { bib, existingSummary, summariesActions } = this.props;
    const metadataId = bib.getIn(['briefInfo', 'metadataId']);
    const summaryId = existingSummary && existingSummary.get('id');
    const summary = this.state.summary;
    const postSuccess = callback;

    if (summaryId) {
      summariesActions.updateSummary({
        summary,
        metadataId,
        summaryId,
        postSuccess
      });
    } else {
      summariesActions.addSummary({
        summary,
        metadataId,
        postSuccess
      });
    }
  }

  renderHeader() {
    return (
      <h2>
        {this.props.existingSummary ? (
          <FormattedMessage id="edit_ugc_summary" />
        ) : (
          <FormattedMessage id="add_ugc_summary" />
        )}
      </h2>
    );
  }

  render() {
    const {
      intl,
      bib,
      existingSummary,
      summariesTransactions,
      shelfItem,
      shelfActions,
      shelfTransactions,
      handleClose
    } = this.props;

    const summaryId = existingSummary && existingSummary.get('id');
    const metadataId = bib.getIn(['briefInfo', 'metadataId']);
    const isSavingSummary = summaryId
      ? summariesTransactions.getIn([metadataId, summaryId, 'isUpdating'], false)
      : summariesTransactions.getIn([metadataId, 'isAdding'], false);
    const placeholder = intl.formatMessage({ id: 'summary_placeholder' });
    const textAreaLabel = <FormattedMessage id="summary_editor_label" />;

    return (
      <TextUGCEditor
        bib={bib}
        characterLimit={CHARACTER_LIMIT}
        className="cp-summary-ugc-editor"
        errorKey="ugcSummary"
        renderHeader={this.renderHeader}
        handleClose={handleClose}
        handleSave={this.handleSave}
        handleTextChange={this.handleTextChange}
        placeholder={placeholder}
        isSaving={isSavingSummary}
        showPrivacyAlert
        shelfItem={shelfItem}
        shelfTransactions={shelfTransactions}
        shelfActions={shelfActions}
        textAreaLabel={textAreaLabel}
        text={this.state.summary}
      />
    );
  }
}

const injectIntlPropTypes = {};

SummaryUGCEditor.propTypes = {
  bib: bibShape.isRequired,
  existingSummary: ugcSummaryShape,
  shelfItem: shelfItemShape,
  handleClose: PropTypes.func.isRequired,
  summariesTransactions: ImmutablePropTypes.map.isRequired,
  shelfTransactions: ImmutablePropTypes.map.isRequired,
  summariesActions: PropTypes.objectOf(PropTypes.func).isRequired,
  shelfActions: PropTypes.objectOf(PropTypes.func).isRequired,
  ...injectIntlPropTypes
};

export default injectIntl(SummaryUGCEditor);
